<template>
  <label :class="['block', wrapperClass]">
    <span v-if="label" class="label">{{ label }}</span>
    <textarea :value="modelValue" :required="required" :placeholder="placeholder" class="field-area" v-bind="textareaAttrs" @input="onInput"></textarea>
  </label>
</template>

<script lang="ts">
import { computed, useAttrs } from "vue";

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    required: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  setup(_: any, { emit }: any) {
    const attrs = useAttrs();
    const wrapperClass = computed(() => attrs.class);
    const textareaAttrs = computed(() => {
      const next = { ...attrs };
      delete next.class;
      return next;
    });
    const onInput = (event: Event) => emit("update:modelValue", (event.target as HTMLTextAreaElement).value);
    return { onInput, wrapperClass, textareaAttrs };
  },
};
</script>
